import { Typography } from '@mui/material';

import { makeStyles } from 'tss-react/mui';

export type ProviderLayoutPageTitleProps = {
  title: string;
};


export const ProviderLayoutPageTitle: React.VFC<ProviderLayoutPageTitleProps> = props => {
  const { classes } = useProviderLayoutPageTitleStyles();

  return (
    <Typography variant="h3" className={classes.title}>
      {props.title}
    </Typography>
  );
};

const useProviderLayoutPageTitleStyles = makeStyles({ name: 'ProviderLayoutPageTitle' })(theme => ({
  title: {
    color: theme.palette.darkSlate.main,
    fontSize: '36px',

    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.h3.fontSize,
    }
  },
}));